import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { GestaoComponent } from './gestao.component';
import { GestaoRoutingModule } from "./gestao-routing.module";
import { RecursosHumanosModule } from "../../recursos-humanos/recursos-humanos.module";
import { EstruturasModule } from "../../estruturas/estruturas.module";
import { BensModule } from "../../bens/bens.module";
import { ViagensModule } from "../../viagens/viagens.module";
import { FrotasModule } from "../../bens/frotas/frotas.module";
import { AbastecimentosModule } from "../../abastecimentos/abastecimentos.module";
import { ManutencoesModule } from "../../manutencoes/manutencoes.module";
import { AlmoxarifadoModule } from "../../almoxarifado/almoxarifado.module";
import { ContasModule } from "../../contas/contas.module";
import { DespachosModule } from "../../despachos/despachos.module";
import { RastreamentosModule } from "../../rastreamentos/rastreamentos.module";

@NgModule({
    imports: [
        SharedModule,
        RecursosHumanosModule,
        EstruturasModule,
        BensModule,
        ViagensModule,
        FrotasModule,
        AbastecimentosModule,
        ManutencoesModule,
        AlmoxarifadoModule,
        ContasModule,
        DespachosModule,
        RastreamentosModule,
        GestaoRoutingModule
    ],
    declarations: [
        GestaoComponent
    ]
})
export class GestaoModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/gestao/gestao.module.ts
 **/